import React, { useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { useLocation, useNavigate } from "react-router-dom";
import { delete_icon } from "../../assets/img";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const MMCEditPlan = () => {
  const { state } = useLocation();
  const type = state?.type;
  const data = state?.data;
  const initial_data = {
    name: data?.name ?? "",
    amount: data?.amount ?? "",
    gst: data?.gst ?? "",
    validity: data?.plan_days ?? "",
    total: data?.total_amount ?? "",
    freeValidity: data?.first_time_offer_days ?? "",
    id: data?.plan_id ?? "",
  };

  const navigate = useNavigate();
  const [hint, setHint] = useState("");
  const [hints, setHints] = useState(data?.terms_conditions ?? []);
  const [planData, setPlanData] = useState(initial_data);

  console.log("type", type);

  const inputOptions = [
    {
      id: 1,
      title: "Plan Name",
      subTitle: "",
      value: planData?.name,
      accessor: "name",
      type: "text",
      editable: type !== "view",
    },
    {
      id: 2,
      title: "Subscription Amount",
      subTitle: "(Month)",
      value: planData.amount,
      accessor: "amount",
      type: "number",
      editable: type === "add",
    },
    {
      id: 3,
      title: "GST%",
      subTitle: "",
      value: planData.gst,
      accessor: "gst",
      type: "number",
      editable: false,
    },
    {
      id: 4,
      title: "Plan Validity",
      subTitle: "(Minimum 7 Days)",
      value: planData?.validity,
      accessor: "validity",
      type: "number",
      editable: type === "add",
    },
    {
      id: 5,
      title: "Total Amount",
      subTitle: "(Month)",
      value: planData?.total,
      accessor: "total",
      type: "number",
      editable: false,
    },
    {
      id: 6,
      title: "Free Plan Validity",
      subTitle: "(Days)",
      value: planData?.freeValidity,
      accessor: "freeValidity",
      type: "number",
      editable: type === "add",
    },
    ...(type !== "add"
      ? [
          {
            id: 7,
            title: "Plan ID",
            subTitle: "",
            value: planData.id,
            accessor: "id",
            type: "text",
            editable: false,
          },
        ]
      : []),
  ];

  const handleChange = (accessor, val) => {
    if (accessor === "validity") {
      if (val >= 7) {
        setPlanData((prev) => ({
          ...prev,
          [accessor]: val,
        }));
      } else {
        return;
      }
    }
    if (accessor === "amount") {
      let amt = Number(val);
      let total = (amt / 100) * Number(planData?.gst);
      handleChange("total", total + amt);
    }
    setPlanData((prev) => ({
      ...prev,
      [accessor]: val,
    }));
  };

  const addHints = () => {
    if (hint.trim()) {
      setHint("");
      let temp = new Set([...hints, hint]);
      setHints([...temp.values()]);
    }
  };
  const deleteHints = (item) => {
    setHints((prev) => prev.filter((i) => i !== item));
  };

  const handleSubmit = async () => {
    Object.entries(planData).forEach((item) => {
      if (item[0] !== "id" && !item[1]) {
        toast.error("please Fill All the Feilds...");
        return;
      }
    });
    if (hints.length === 0) {
      toast.error("Please add Hints...");
      return;
    }
    let { amount, freeValidity, gst, name, total, validity } = planData;
    let payload = {
      name: name,
      amount: amount,
      gst: gst,
      plan_days: validity,
      first_time_offer_days: freeValidity,
      total_amount: total,
      terms_conditions: hints,
    };
    let method = type === "edit" ? patch : post;
    let url =
      type === "edit" ? `${URLS.MMC_PLANS}${data?.id}/` : URLS.MMC_PLANS;
    let res = await method(url, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate(-1);
    }
  };
  return (
    <div>
      <Topbar header={"MMC Plans"} back={true} />
      <h5>Creats MMC Plans</h5>

      {/* inputs  */}
      <div className="row mb-4 mt-4">
        {inputOptions.map((item, ind) => {
          return (
            <div key={ind} className="col-md-6 mb-3">
              <p className="f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16">
                {item.title}{" "}
                {item.subTitle && (
                  <span
                    className="f1 fs-sm-8 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14"
                    style={{ color: "#9A36E6" }}
                  >
                    <i>{item.subTitle}</i>
                  </span>
                )}
              </p>
              <input
                name="userName"
                type={item.type}
                value={item.value}
                onChange={(e) => {
                  if (
                    e.target.value > 0 ||
                    !e.target.value ||
                    item?.type === "text"
                  )
                    handleChange(item.accessor, e.target.value);
                }}
                className={`input-box mt-2 ${item.editable ? "" : "cursor"}`}
                placeholder={`Enter ${item.title}`}
                disabled={!item.editable}
              />
            </div>
          );
        })}
      </div>
      {/* details  */}
      <div style={{ backgroundColor: "#F3F4F6" }} className=" rounded p-3">
        <h5 className="f4">Plan Details</h5>
        {type !== "view" && (
          <div className="d-flex ae-jb mt-3 mb-3 gap-2">
            <textarea
              style={{
                flex: 1,
                backgroundColor: "#F3F4F6",
                borderWidth: 1,
                borderColor: "#CBD5E1",
                borderStyle: "solid",
              }}
              value={hint}
              onChange={(e) => setHint(e.target.value)}
              className=" rounded-3 p-2 f1  fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16"
              multiple
            />

            <button
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn bg-primar"
              onClick={() => addHints()}
            >
              + Add
            </button>
          </div>
        )}

        <div>
          {hints.length !== 0 && (
            <ul className="input-border overflow-scroll mt-2">
              {hints?.map((item, index) => (
                <li key={index} className="d-flex as-jb gap-3 mt-2">
                  <div className="d-flex as-js gap-3">
                    <ReceiptLongOutlinedIcon
                      htmlColor="#A855F7"
                      fontSize="small"
                    />
                    <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16  text-start">
                      {item}
                    </p>
                  </div>
                  {type !== "view" && (
                    <img
                      src={delete_icon}
                      className="delete-btn"
                      onClick={() => deleteHints(item)}
                      alt="delete"
                    />
                  )}
                </li>
              ))}
            </ul>
          )}
          {type !== "view" && (
            <button onClick={handleSubmit} className="submit-btn mt-3 ">
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MMCEditPlan;
